export default {
  name: '褐色',
  style: {
    color_base: '57, 45, 32',
    color_back_base: '239, 225, 199',
    alpha_slight: '.03'
  }
};
